import { IAppDataState, ICustomersState, IOrdersState, IReportsState } from './../../types/interfaces'

const state: State = {
  appData: {
    currentUser: undefined,
    version: undefined,
  },
  contracts: {
    stats: {},
  },
  reports: {
    availableReports: [],
    report: null,
  },
  customers: {
    customers: [],
    filteredCustomers: [],
    customersAdmin: [],
    unassignedCustomers: [],
    loading: false,
  },
  tenantsTags: [],

  orders: {
    formsLoadInProgress: false,
    workflowsConfigs: [],
    supplierWorkflowsConfigs: [],
    forms: [],
    data: [],
    tenantFuelCardSets: [],
    fuelCards: [],
  },
}

export default state

export interface State {
  appData: IAppDataState
  contracts: ContractsState
  reports: IReportsState
  customers: ICustomersState
  tenantsTags: string[]
  orders: IOrdersState
}

export interface ContractsState {
  stats: { [id: string]: { [id: number]: number } }
}
